import { appConfig } from "@configs/appConfig";

const logfilters = ["general"];

const logAddFilter = (newFilterName) => {
  if (newFilterName instanceof Array) {
    for (const v in newFilterName) {
      logfilters.push(newFilterName[v]);
    }
  } else {
    logfilters.push(newFilterName);
  }
};
const logClearFilters = () => {
  logfilters.splice(0, logfilters.length);
};

const logDumpFilters = () => {
  console.log("ActiveFilters", logfilters);
};

const logSetFilterProfile = (profileName) => {
  if (appConfig.filterProfiles[profileName] !== "undefined") {
    logClearFilters();
    logAddFilter(appConfig.filterProfiles[profileName]);
  }

  // console.log(appConfig)
  // console.log(profileName)
};

const logAlways = (...params) => {
  console.log(params);
};

const logFilter = (a, ...params) => {
  if (logfilters.indexOf(a) !== -1) {
    console.log(`%c[${a}]`, "color:green", ...params);
    // if (window.logHistory === null) {
    // 	console.log("adding logHistory")
    // 	window.logHistory = []
    // } else {
    // 	console.log('44', window.logHistory)
    // }
    // if (window.logHistory[a] === null || window.logHistory[a] === undefined) {
    // 	console.log('adding logHistory', a)
    // } else {
    // 	console.log('49')
    // }
    // window.logHistory[a] = new Array()
  }
};

const logErrorFilter = (a, ...params) => {
  try {
    if (logfilters.indexOf(a) !== -1) {
      console.error(`%c[${a}]`, "font-weight:bold;color:white", ...params);
    }
  } catch (e) {
    console.error("eror attempting to report error to server", e);
    // eat this error
  }
};

const logReset = () => {
  console.clear();
};

const jumpToExternalURL = (url, target = "blank") => {
  logFilter("nav", url);
  window.open(url, target);
};

export {
  jumpToExternalURL,
  logAlways,
  logFilter,
  logErrorFilter,
  logDumpFilters,
  logAddFilter,
  logSetFilterProfile,
  logClearFilters,
  logReset,
};

//export const is = (fileName, ext) => new RegExp(`.${ext}\$`).test(fileName);
